import { ArrowLeftIcon } from "@heroicons/react/24/outline";
import { Link } from "@inertiajs/react";
import Layout from "@/components/Layout";
import PersonaForm from "@/components/PersonaForm";
import type { Persona } from "@/types";

type NewProps = {
  persona: Persona;
};

export default function New({ persona }: NewProps) {
  return (
    <Layout title="Create New Persona">
      <div className="mb-6 flex items-center">
        <Link href="/personas" className="mr-4 text-gray-500 hover:text-primary" aria-label="Back to Personas">
          <ArrowLeftIcon className="h-6 w-6" />
        </Link>
        <h1 className="text-2xl font-semibold">Create New Persona</h1>
      </div>

      <div className="mx-auto max-w-5xl">
        <PersonaForm
          cancelHref="/personas"
          formTitle="Create New Persona"
          method="post"
          url="/personas"
          persona={persona}
          submitLabel="Create Persona"
        />
      </div>
    </Layout>
  );
}
